import chPlayImg from "../assets/ch_play.png";
import appNameImg from "../assets/logo.png";
import userListFeatureImg from "../assets/user_list_feature.png";
import videoCallImg from "../assets/video_call.png";
import videoCallFeatureImg from "../assets/video_call_feature.png";
import ComplainHandlingComponent from "../components/staticPage/complainHandling.component";
import PaymentRuleComponent from "../components/staticPage/paymentRule.component";
import PointComponent from "../components/staticPage/point.component";
import PrivacyPolicyComponent from "../components/staticPage/privacyPolicy.component";
import TermComponent from "../components/staticPage/term.component";
import TransactionRuleComponent from "../components/staticPage/transactionRule.component";
import ConfirmAdultModal from "../components/confirm/ConfirmAdultModal.components";
import "../styles/HomeLayout.css";

function HomeLayout({ children }: any) {

  return (
    <div className="home-wrapper">
      <ConfirmAdultModal />
      {children}
      <div id="top" className="top-wrapper"></div>

      <div className="main-content">
        <section id="section1">
          <p>ビデオ通話で息抜きしよう！</p>
          <img className="app-name-img" src={appNameImg} alt="app-name-img"/>
          <img className="video-call-img" src={videoCallImg} alt="video-call-img"/>
        </section>
        <section id="section2">
          <p className="title">あんずとは</p>
          <p>旅行先を相談したり＆旅行・観光した感想などをシェアして、楽しいトラベルライフを過ごそう！<br/>
            旅行に関する情報をシェアできますので、<br/>
            あなたが求める旅行や体験が見つかります。</p>
        </section>
        <section id="section3">
          <h2>あんずの機能</h2>
          <div className="user-list-feature">
            <div className="user-list-description">
              <p className="title">旅の計画をメッセージや旅のしおりで相談できます。</p>
              <p>これから行こうとしている旅のおすすめスポットを聞いてみよう！</p>
              <br />
              <p>あなたにあった旅行先を相談して解決しよう！</p>
            </div>
            <div className="user-list-feature-img">
              <img className="" src={userListFeatureImg} alt="user-list-feature-img"/>
            </div>
          </div>
          <div className="video-call-feature">
            <div className="video-call-feature-img">
              <img className="" src={videoCallFeatureImg} alt="video-call-feature-img"/>
            </div>
            <div className="video-call-description">
              <p className="title">旅行先の風景を見せ合いながら、
              複数で旅行へ行った気分を味わうことができます。</p>
              <p>旅をされている方のリアルタイムの声を聞くことができます。</p>
            </div>
          </div>
        </section>
        <section id="section4">
          <TermComponent/>
        </section>
        
        <section id="section5">
          <PrivacyPolicyComponent/>
        </section>
  
        <section id="section6">
          <ComplainHandlingComponent/>
        </section>
  
        <section id="section7">
          <TransactionRuleComponent/>
        </section>
        <section id="section8">
          <PaymentRuleComponent/>
        </section>
        <section id="section9">
          <PointComponent/>
        </section>
        <section id="section10" className="payment-method">
          <p className="title">決済方法</p>
          <div className="ch-play-link">
            <img src={chPlayImg} alt="ch-play-img"/>
            <p className="ch-play-title">GooglePlay決済</p>
            <p className="ch-play-subtitle">GooglePlay決済が利用可能です。</p>
          </div>
        </section>
        <div className="footer">
        <p>大阪府公安委員会　映像送信型風俗特殊営業済 第44688号</p>
        <br />
        <p>© anzu-travel.com</p>
      </div>
      </div> 
    </div>
  );
}

export default HomeLayout;
